export default "__VITE_ASSET__DrkvCZDo__"